'use client';
import React, { useEffect } from 'react';
import { useStickyBox } from 'react-sticky-box';
import { ExchangeNode } from '@/types/global';
import { LayoutProps } from '@/types/generalSettings';
import BannerSidebar from '@/components/(features)/bannerSidebar';
import useStoreID from '@/stores/admin/IDStore';

interface SingleBrokerMainProps {
    banners?: LayoutProps.Banners | undefined;
    post?: ExchangeNode;
}

const AsideBroker: React.FC<SingleBrokerMainProps> = ({ post, banners }) => {
    const stickyRef = useStickyBox({ offsetTop: 100, offsetBottom: 20 });
    const { setPostId } = useStoreID();

    useEffect(() => {
        if (post?.databaseId) {
            setPostId(post.databaseId);
        }
    }, [post, setPostId]);

    return (
        <aside className={'lg:col-span-3 max-xl:col-span-12 py-3 lg:pr-3'}>
            <div ref={stickyRef}>
                <BannerSidebar banners={banners} />
            </div>
        </aside>
    );
};

export default AsideBroker;
